<template>
  <!-- eslint-disable max-len -->
  <div>
    <bpc-page-top :breadcrumb=breadcrumb :links=links></bpc-page-top>

    <b-row class="p-3">
      <b-col md="3">
          <div class="card-shadow-primary profile-responsive card-border mb-3 card">
                    <div class="dropdown-menu-header">
                        <div class="dropdown-menu-header-inner bg-danger">
                            <div class="menu-header-image" style="background-image: url('assets/images/dropdown-header/abstract1.jpg')"></div>
                            <div class="menu-header-content btn-pane-right">
                                <div class="avatar-icon-wrapper mr-2 avatar-icon-xl">
                                    <div class="avatar-icon"><img
                                        src="@/assets/images/avatars/3.jpg"
                                        alt="Avatar 5"></div>
                                </div>
                                <div><h5 class="menu-header-title">Mathew Mercer</h5><h6 class="menu-header-subtitle">Sales Manager</h6></div>
                                <div class="menu-header-btn-pane">
                                    <button class="btn-icon mr-2 btn-icon-only btn btn-warning btn-sm"><i class="pe-7s-config btn-icon-wrapper"> </i></button>
                                    <button class="btn-icon btn btn-success btn-sm">View Profile</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                            <div class="widget-content p-0">
                                <div class="widget-content-wrapper">
                                    <div class="widget-content-left mr-3">
                                        <div class="icon-wrapper m-0">
                                            <div class="progress-circle-wrapper">
                                                <vue-circle
                                                    :progress="62"
                                                    :size="52"
                                                    :reverse="false"
                                                    line-cap="round"
                                                    :fill="f1"
                                                    empty-fill="rgba(0, 0, 0, .12)"
                                                    :animation-start-value="0.0"
                                                    :start-angle="0"
                                                    insert-mode="append"
                                                    :thickness="3"
                                                    :show-percent="true">
                                                </vue-circle>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="widget-content-left">
                                        <div class="widget-heading">January Sales</div>
                                        <div class="widget-subheading">Lorem ipsum dolor</div>
                                    </div>
                                    <div class="widget-content-right">
                                        <div class="widget-numbers widget-numbers-sm text-primary"><span>764</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item">
                            <div class="widget-content p-0">
                                <div class="widget-content-wrapper">
                                    <div class="widget-content-left mr-3">
                                        <div class="icon-wrapper m-0">
                                            <div class="progress-circle-wrapper">
                                                <vue-circle
                                                    :progress="21"
                                                    :size="52"
                                                    :reverse="false"
                                                    line-cap="round"
                                                    :fill="f5"
                                                    empty-fill="rgba(0, 0, 0, .12)"
                                                    :animation-start-value="0.0"
                                                    :start-angle="0"
                                                    insert-mode="append"
                                                    :thickness="3"
                                                    :show-percent="true">
                                                </vue-circle>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="widget-content-left">
                                        <div class="widget-heading">February Sales</div>
                                        <div class="widget-subheading">Maecenas tempus, tellus</div>
                                    </div>
                                    <div class="widget-content-right">
                                        <div class="widget-numbers widget-numbers-sm text-warning"><span>194</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item">
                            <div class="widget-content p-0">
                                <div class="widget-content-wrapper">
                                    <div class="widget-content-left mr-3">
                                        <div class="icon-wrapper m-0">
                                            <div class="progress-circle-wrapper">
                                                <vue-circle
                                                    :progress="68"
                                                    :size="52"
                                                    :reverse="false"
                                                    line-cap="round"
                                                    :fill="f6"
                                                    empty-fill="rgba(0, 0, 0, .12)"
                                                    :animation-start-value="0.0"
                                                    :start-angle="0"
                                                    insert-mode="append"
                                                    :thickness="3"
                                                    :show-percent="true">
                                                </vue-circle>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="widget-content-left">
                                        <div class="widget-heading">March Sales</div>
                                        <div class="widget-subheading">Donec vitae sapien</div>
                                    </div>
                                    <div class="widget-content-right">
                                        <div class="widget-numbers widget-numbers-sm text-danger"><span>-54 $</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item">
                            <div class="widget-content p-0">
                                <div class="widget-content-wrapper">
                                    <div class="widget-content-left mr-3">
                                        <div class="icon-wrapper m-0">
                                            <div class="progress-circle-wrapper">
                                                <vue-circle
                                                    :progress="91"
                                                    :size="52"
                                                    :reverse="false"
                                                    line-cap="round"
                                                    :fill="fill1"
                                                    empty-fill="rgba(0, 0, 0, .12)"
                                                    :animation-start-value="0.0"
                                                    :start-angle="0"
                                                    insert-mode="append"
                                                    :thickness="3"
                                                    :show-percent="true">
                                                </vue-circle>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="widget-content-left">
                                        <div class="widget-heading">April Sales</div>
                                        <div class="widget-subheading">Curabitur ullamcorper ultricies</div>
                                    </div>
                                    <div class="widget-content-right">
                                        <div class="widget-numbers widget-numbers-sm text-info"><span>45 $</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

      </b-col>
      <b-col md="9">

    <b-card _title="Example" class="main-card mb-4" no-body>
      <b-tabs card _pills class="card-header-tab-animation">
        <b-tab title="Dashboard" active>


        </b-tab>
        <b-tab title="Contact data">
          <form class="m-4">
            <b-row class="">
      <b-col md="8">
        <h4 class="card-title">Basic Example</h4>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="position-relative form-group"><label for="exampleEmail11" class="">Email</label><input name="email" id="exampleEmail11" placeholder="with a placeholder" type="email" class="form-control"></div>
                  </div>
                  <div class="col-md-6">
                    <div class="position-relative form-group"><label for="examplePassword11" class="">Password</label><input name="password" id="examplePassword11" placeholder="password placeholder" type="password" class="form-control"></div>
                  </div>
                </div>
                <div class="position-relative form-group"><label for="exampleAddress" class="">Address</label><input name="address" id="exampleAddress" placeholder="1234 Main St" type="text" class="form-control"></div>
                <div class="position-relative form-group"><label for="exampleAddress2" class="">Address 2</label><input name="address2" id="exampleAddress2" placeholder="Apartment, studio, or floor" type="text" class="form-control"></div>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="position-relative form-group"><label for="exampleCity" class="">City</label><input name="city" id="exampleCity" type="text" class="form-control"></div>
                  </div>
                  <div class="col-md-4">
                    <div class="position-relative form-group"><label for="exampleState" class="">State</label><input name="state" id="exampleState" type="text" class="form-control"></div>
                  </div>
                  <div class="col-md-2">
                    <div class="position-relative form-group"><label for="exampleZip" class="">Zip</label><input name="zip" id="exampleZip" type="text" class="form-control"></div>
                  </div>
                </div>
                <div class="position-relative form-check"><input name="check" id="exampleCheck" type="checkbox" class="form-check-input"><label for="exampleCheck" class="form-check-label">Check me out</label></div>
                <button class="mt-2 btn btn-primary">Sign in</button>
      </b-col>
      <b-col md="4">
        <h4 class="card-title">Basic Example</h4>
        <div class="form-row">
                  <div class="col-md-12">
                    <div class="position-relative form-group"><label for="exampleEmail11" class="">Email</label><input name="email" id="exampleEmail11" placeholder="with a placeholder" type="email" class="form-control"></div>
                  </div>
                  <div class="col-md-12">
                    <div class="position-relative form-group"><label for="examplePassword11" class="">Password</label><input name="password" id="examplePassword11" placeholder="password placeholder" type="password" class="form-control"></div>
                  </div>
                </div>
      </b-col>
      </b-row>
              </form>

              </b-tab>
        <b-tab title="Bookings">
          <bpc-table-bookings></bpc-table-bookings>
        </b-tab>
        <b-tab title="Subscriptions">
          <bpc-table-subscriptions></bpc-table-subscriptions>
        </b-tab>
        <b-tab title="Activities">
          <bpc-table-activities></bpc-table-activities>
        </b-tab>
        <b-tab title="Documents">
          <bpc-table-documents></bpc-table-documents>
        </b-tab>
        <b-tab title="Orders">
          <bpc-table-orders></bpc-table-orders>
        </b-tab>
        <b-tab title="Logs">
          <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a
            type specimen book. It has
            survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </p>
        </b-tab>
      </b-tabs>

    </b-card>


</b-col>
</b-row>
  </div>
</template>

<script>
import BpcPageTop from '@/mockups/layouts/components/BpcPageTop.vue';
import BpcTableBookings from '@/mockups/tables/BpcTableBookings.vue';
import BpcTableSubscriptions from '@/mockups/tables/BpcTableSubscriptions.vue';
import BpcTableActivities from '@/mockups/tables/BpcTableActivities.vue';
import BpcTableDocuments from '@/mockups/tables/BpcTableDocuments.vue';
import BpcTableOrders from '@/mockups/tables/BpcTableOrders.vue';

import avatar1 from '../../assets/avatars/1.jpg';
import avatar2 from '../../assets/avatars/2.jpg';
import avatar3 from '../../assets/avatars/3.jpg';
import avatar4 from '../../assets/avatars/4.jpg';
import avatar5 from '../../assets/avatars/5.jpg';
import avatar6 from '../../assets/avatars/6.jpg';
import avatar7 from '../../assets/avatars/7.jpg';
import avatar8 from '../../assets/avatars/8.jpg';
import avatar9 from '../../assets/avatars/9.jpg';
import avatar10 from '../../assets/avatars/10.jpg';

const item = {
  check: null,
  birthdate: { date: '1979-08-24', age: 40 },
  type: 'Individual',
  status: 'active',
  name: { first: 'Dickerson', last: 'Macdonald' },
  img_url: avatar1,
};

export default {
  components: {
    BpcPageTop,
    BpcTableBookings,
    BpcTableSubscriptions,
    BpcTableActivities,
    BpcTableDocuments,
    BpcTableOrders,
  },
  data: () => ({
    header: {
      heading: `${item.name.first} ${item.name.last}`,
      subheading: item.birthdate.date,
      avatar: item.img_url,
      icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
      actions: {
        delete: false, bulk: false, new: false, edit: true, actions: true,
      },
    },
    breadcrumb: ['Dashboard', 'Contacts', `${item.name.first} ${item.name.last}`],
    links: ['Help', 'Settings'],
    item,
  }),
};
</script>

<style scoped>
.card-title {
    padding-left: 0;
}
</style>
